import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MDBBtn } from "mdb-react-ui-kit";
import "../CHAMPMainView/CHAMPMainView.css";

import { getMyGames, isOk } from "Projects/CHAMP_championsjourney_project/Utils/ChampService";
import { getApp, getAppPermisions } from "Projects/CC_cubi_clan_project/Utils/PermissionManager";
import CreateGameModal from "Projects/CHAMP_championsjourney_project/Components/CreateGameModal/CreateGameModal";
import JoinGameModal from "Projects/CHAMP_championsjourney_project/Components/JoinGameModal/JoinGameModal";

export default function CHAMPHomeView({ onLoading }) {
  const navigate = useNavigate();
  const [games, setGames] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showJoin, setShowJoin] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  const loadGames = useCallback(async () => {
    onLoading && onLoading(true);
    try {
      const res = await getMyGames();
      if (isOk(res) && Array.isArray(res.DATA)) {
        setGames(res.DATA);
      }
    } finally {
      onLoading && onLoading(false);
    }
  }, [onLoading]);

  useEffect(() => { loadGames(); }, [loadGames]);

  useEffect(() => {
    (async () => {
      try {
        const app = await getApp("CHAMP", () => {});
        if (app) {
          const perms = await getAppPermisions(app, () => {});
          if (Array.isArray(perms) && perms.some((p) => p && (p.nombre === "APP_ADMIN" || p.nombre === "APP_MANAGER"))) {
            setIsAdmin(true);
          }
        }
      } catch (e) { /* sin admin */ }
    })();
  }, []);


  return (
    <div className="champ-home">
      <h4 className="champ-section-title">Mis partidas</h4>
      <div className="champ-toolbar">
        <MDBBtn className="champ-btn-primary" onClick={() => setShowCreate(true)}>
          + Nueva partida
        </MDBBtn>
        <MDBBtn className="champ-btn-secondary" onClick={() => setShowJoin(true)}>
          Unirse con código
        </MDBBtn>
        {isAdmin && (
          <MDBBtn className="champ-btn-secondary" onClick={() => navigate("/champ/admin")}>
            ⚙️ Administración
          </MDBBtn>
        )}
      </div>

      {games.length === 0 ? (
        <div className="champ-empty">
          <p>Todavía no participas en ninguna partida.</p>
          <p className="champ-text-muted">Crea una partida nueva o únete con un código.</p>
        </div>
      ) : (
        <div className="champ-games-grid">
          {games.map((g) => (
            <div key={g.idPartida} className="champ-game-card" onClick={() => navigate("/champ/game/" + g.codigo)}>
              <h5>{g.nombre}</h5>
              <div className="champ-text-muted">Código <strong>{g.codigo}</strong></div>
              <div className="champ-game-meta">
                <span className="champ-chip champ-chip-region">{g.regionInicio}</span>
                {g.rolUsuario === "GM" && <span className="champ-chip champ-chip-gm">GM</span>}
                <span>{g.numMiembros} 👤</span>
                <span>{g.estado}</span>
              </div>
            </div>
          ))}
        </div>
      )}

      <CreateGameModal
        show={showCreate}
        setShow={setShowCreate}
        onCreated={(data) => { loadGames(); if (data?.codigo) navigate("/champ/game/" + data.codigo); }}
      />
      <JoinGameModal
        show={showJoin}
        setShow={setShowJoin}
        onJoined={(data) => { loadGames(); if (data?.codigo) navigate("/champ/game/" + data.codigo); }}
      />
    </div>
  );
}
